import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Box } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-premium";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { stockTransferRequisitionPagingAPI } from "../../../api/url";
import { DynamicCatalogBuilder } from "../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder";
import { DesktopTabComponent } from "../../../components/molecules/desktopTabComponent";
import { ESystemName, LOCAL_STORAGE_KEYS } from "../../../constants";
import { useAppSelector } from "../../../store/hooks";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { CustomCrossIcon } from "../../jobCardDetails/assets/customIcons";
import { purchaseOrderCancelAPI } from "../../purchaseOrder/services/apiCalls";
import CancelDocument from "../../spareParts/purchaseRequistion/components/cancelDocument";
import { cancellationReasonPRListAPICall } from "../../spareParts/purchaseRequistion/services/apiCall";
import { WarehouseOutwardPagingAPI } from "../apiCalls";
import { FilterWarehouseOutward } from "../components/filterWarehouseOutward";
import { MoreDetails } from "../components/moreDetails.warehouseOutword";
import { WarehouseOutwardKeys } from "../entity";
import HeaderCatalogPageComponent from "../../../components/templates/headerCatalogPageUpdated";
export var WarehouseOutwardList = function (props) {
    var _crud$filterValue, _crud$WarehouseOutwar2;
    var navigate = useNavigate();
    var crud = useAppSelector(function (state) { return state.crud; });
    var _a = useState("list"), activeView = _a[0], setActiveView = _a[1];
    var _b = useState(false), isFilterOpen = _b[0], setFilterOpen = _b[1];
    var onToggleViewChange = function (view) {
        setActiveView(view);
    };
    var _c = useState(false), openDrawer = _c[0], setOpenDrawer = _c[1];
    var _d = useState(null), rowData = _d[0], setRowData = _d[1];
    var isAllViewActive = useAppSelector(function (state) { return state.common; }).isAllViewActive;
    var _e = useState(0), totalAmount = _e[0], setTotalAmount = _e[1];
    var filterValue = (_crud$filterValue = crud['filterValue']) === null || _crud$filterValue === void 0 ? void 0 : _crud$filterValue.data;
    var _f = useState(false), openCancelPopUp = _f[0], setOpenCancelPopUp = _f[1];
    var _g = useState(""), rowId = _g[0], setRowId = _g[1];
    var listVariants = ["My outwards", "All outwards"];
    var _h = useState(listVariants.length > 0 && isAllViewActive ? listVariants[0] : listVariants[1]), selectedListVariant = _h[0], setSelectedListVariant = _h[1];
    var handleRowCancelClick = function (id) {
        setRowId(id);
        setOpenCancelPopUp(true);
    };
    var handleCancelClose = function () {
        setOpenCancelPopUp(false);
    };
    var totalAmountCount = function () {
        var c = 0;
        {
            var _crud$WarehouseOutwar;
            (_crud$WarehouseOutwar = crud[WarehouseOutwardKeys.ItemsPaging]) === null || _crud$WarehouseOutwar === void 0 || (_crud$WarehouseOutwar = _crud$WarehouseOutwar.data) === null || _crud$WarehouseOutwar === void 0 || _crud$WarehouseOutwar.map(function (item, index) {
                if (item !== null && item !== void 0 && item.Amount) {
                    c += item === null || item === void 0 ? void 0 : item.Amount;
                    setTotalAmount(c);
                }
            });
        }
    };
    var customActionColumns = [{
            field: "SrNo",
            headerName: "Sr. No",
            width: 50,
            valueFormatter: function (val, row, col, api) { return api.current.getRowIndexRelativeToVisibleRows(row.id) + 1; },
            sortable: false
        }, {
            field: "DocumentCode",
            headerName: "IWO Number",
            minWidth: 200,
            flex: 1
        }, {
            field: "ExpectedTransferDate",
            headerName: "Transfer Date",
            minWidth: 200,
            valueFormatter: function (val) { return val ? dayjs(val).format("DD MMM, YYYY") : "-"; },
            flex: 1
        }, {
            field: "CreatedBy",
            headerName: "CreatedBy",
            minWidth: 200,
            valueFormatter: function (val, row) {
                var _row$CreatedByFirstNa, _row$CreatedByLastNam;
                return row !== null && row !== void 0 && row.CreatedByLastName || row !== null && row !== void 0 && row.CreatedByFirstName ? "".concat((_row$CreatedByFirstNa = row === null || row === void 0 ? void 0 : row.CreatedByFirstName) !== null && _row$CreatedByFirstNa !== void 0 ? _row$CreatedByFirstNa : "", " ").concat((_row$CreatedByLastNam = row === null || row === void 0 ? void 0 : row.CreatedByLastName) !== null && _row$CreatedByLastNam !== void 0 ? _row$CreatedByLastNam : "") : "-";
            },
            flex: 1
        }, {
            field: "CreatedOn",
            headerName: "Created Date",
            minWidth: 200,
            valueFormatter: function (val) { return val ? dayjs(val).format("DD MMM, YYYY") : "-"; },
            flex: 1
        }, {
            field: "SourceWarehouseName",
            headerName: "Source warehouse",
            minWidth: 200,
            flex: 1
        }, {
            field: "DestinationWarehouse",
            headerName: "Destination warehouse",
            minWidth: 200,
            flex: 1
        }, {
            field: "TransporterName",
            headerName: "Transporter name",
            minWidth: 200,
            flex: 1
        }, {
            field: "ShippingMethodName",
            headerName: "Shipping method",
            minWidth: 200,
            flex: 1
        }, {
            field: "TotalQuantity",
            headerName: "Total qty",
            valueFormatter: function (val) {
                var _Number;
                return (_Number = Number(val)) === null || _Number === void 0 ? void 0 : _Number.toFixed(2);
            },
            minWidth: 80,
            align: "right",
            headerAlign: "right",
            flex: 1
        }, {
            type: "actions",
            field: "actions",
            headerName: "",
            getActions: function (params) {
                return [
                    /*#__PURE__*/
                    // <GridActionsCellItem
                    //   label="Edit"
                    //   icon={<Edit />}
                    //   onClick={() =>
                    //     navigate(`/warehouseOutword/edit/${params?.row?.id}`)
                    //   }
                    //   showInMenu
                    // />,
                    React.createElement(GridActionsCellItem, {
                        label: "Cancel",
                        icon: /*#__PURE__*/ React.createElement(CustomCrossIcon, {
                            style: {
                                height: "16px",
                                width: "16px"
                            }
                        }),
                        showInMenu: true,
                        onClick: function () {
                            var _params$row;
                            return handleRowCancelClick(params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.id);
                        }
                    })
                ];
            }
        }];
    var handleRowClick = function (row) {
        setRowData(row);
        setOpenDrawer(true);
        totalAmountCount();
    };
    var handleDrawerClose = function () {
        setRowData(undefined);
        setOpenDrawer(false);
    };
    var getRequest = function () {
        var _filterValue$Status, _getLocalStorageItem;
        var request = {
            FromDate: filterValue !== null && filterValue !== void 0 && filterValue.FromDate ? filterValue === null || filterValue === void 0 ? void 0 : filterValue.FromDate : "",
            ToDate: filterValue !== null && filterValue !== void 0 && filterValue.ToDate ? filterValue === null || filterValue === void 0 ? void 0 : filterValue.ToDate : filterValue !== null && filterValue !== void 0 && filterValue.FromDate ? filterValue === null || filterValue === void 0 ? void 0 : filterValue.FromDate : "",
            Status: filterValue === null || filterValue === void 0 || (_filterValue$Status = filterValue.Status) === null || _filterValue$Status === void 0 ? void 0 : _filterValue$Status.map(function (item) { return item === null || item === void 0 ? void 0 : item.Name; }),
            IdentityId: selectedListVariant === "My outwards" ? (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.IdentityId : undefined
        };
        if (filterValue !== null && filterValue !== void 0 && filterValue.Type) {
            request = _objectSpread(_objectSpread({}, request), {}, {
                Type: filterValue === null || filterValue === void 0 ? void 0 : filterValue.Type
            });
        }
        if (filterValue !== null && filterValue !== void 0 && filterValue.SourceTenantId) {
            request = _objectSpread(_objectSpread({}, request), {}, {
                SourceTenantId: filterValue === null || filterValue === void 0 ? void 0 : filterValue.SourceTenantId
            });
        }
        if (filterValue !== null && filterValue !== void 0 && filterValue.TransporterId) {
            request = _objectSpread(_objectSpread({}, request), {}, {
                TransporterId: filterValue === null || filterValue === void 0 ? void 0 : filterValue.TransporterId
            });
        }
        if (filterValue !== null && filterValue !== void 0 && filterValue.SourceParentTenantId) {
            request = _objectSpread(_objectSpread({}, request), {}, {
                SourceParentTenantId: filterValue === null || filterValue === void 0 ? void 0 : filterValue.SourceParentTenantId
            });
        }
        if (filterValue !== null && filterValue !== void 0 && filterValue.SourceWarehouseId) {
            request = _objectSpread(_objectSpread({}, request), {}, {
                SourceWarehouseId: filterValue === null || filterValue === void 0 ? void 0 : filterValue.SourceWarehouseId
            });
        }
        if (filterValue !== null && filterValue !== void 0 && filterValue.DestinationWarehouseId) {
            request = _objectSpread(_objectSpread({}, request), {}, {
                DestinationWarehouseId: filterValue === null || filterValue === void 0 ? void 0 : filterValue.DestinationWarehouseId
            });
        }
        return request;
    };
    useEffect(function () {
        WarehouseOutwardPagingAPI({
            key: WarehouseOutwardKeys.paging,
            request: getRequest(),
            url: stockTransferRequisitionPagingAPI
        });
    }, [selectedListVariant, filterValue]);
    var handleSelectMenu = function (listVariant) {
        setSelectedListVariant(listVariant);
    };
    var handleClickFilterIcon = function () {
        setFilterOpen(function (prev) { return !prev; });
    };
    var handleRowEditClick = function (id) {
        navigate("/warehouseOutword/edit/".concat(id, "?mode=edit"));
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DesktopTabComponent, {
        items: listVariants
    }), /*#__PURE__*/ React.createElement(HeaderCatalogPageComponent, {
        handleClickFilterIcon: handleClickFilterIcon,
        selectedMenuItem: selectedListVariant,
        menus: listVariants.length > 0 ? listVariants : undefined,
        onSelectMenu: handleSelectMenu,
        activeView: activeView,
        onToggleView: onToggleViewChange,
        totalCount: (_crud$WarehouseOutwar2 = crud[WarehouseOutwardKeys.paging]) === null || _crud$WarehouseOutwar2 === void 0 ? void 0 : _crud$WarehouseOutwar2.count,
        onClickCreateModule: function () {
            navigate("/createInterWarehouseOutward");
        },
        createButtonText: "New",
        isCreateButton: true,
        moduleName: ESystemName.InterWarehouseOutword
    }), /*#__PURE__*/ React.createElement(Box, {
        p: 2
    }, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        getPagingData: WarehouseOutwardPagingAPI,
        pagingAPIKey: WarehouseOutwardKeys.paging,
        columns: customActionColumns,
        pagingAPIRequest: getRequest(),
        dataGridProps: {
            paginationMode: "client",
            onCellClick: function (params, event) {
                if (!((params === null || params === void 0 ? void 0 : params.field) == "actions")) {
                    handleRowClick(params);
                }
            },
            disableColumnMenu: false
        }
    })), /*#__PURE__*/ React.createElement(MoreDetails, {
        handleRowEditClick: handleRowEditClick,
        handleDrawerClose: handleDrawerClose,
        openDrawer: openDrawer,
        rowData: rowData,
        isEditable: false
    }), /*#__PURE__*/ React.createElement(FilterWarehouseOutward, {
        isFilterOpen: isFilterOpen,
        setFilterOpen: handleClickFilterIcon
    }), /*#__PURE__*/ React.createElement(CancelDocument, {
        openPopper: openCancelPopUp,
        cancellationReasonAPI: cancellationReasonPRListAPICall,
        cancelAPI: purchaseOrderCancelAPI,
        id: rowId,
        handleClose: handleCancelClose
    }));
};
